/* Größenauswahl immer nach Größe sortieren (XS, S, M, L, XL, 2XL, 3XL ...),
   unabhängig von der Reihenfolge in den Produktdaten. */
(function () {
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL', '6XL'];

  function rank(value) {
    var i = ORDER.indexOf(String(value).trim().toUpperCase());
    return i < 0 ? 999 : i;
  }

  function isSorted(list) {
    for (var i = 1; i < list.length; i++) {
      if (list[i].rank < list[i - 1].rank) return false;
    }
    return true;
  }

  // Teeinblue-Formular: .tee-option--size .tee-option-inner > .tee-radio
  function sortTeeinblue(root) {
    root.querySelectorAll('.tee-option--size .tee-option-inner').forEach(function (box) {
      var items = Array.prototype.slice.call(box.children).filter(function (c) {
        return c.classList.contains('tee-radio') && c.querySelector('input');
      });
      if (items.length < 2) return;
      var list = items.map(function (el, idx) {
        return { el: el, idx: idx, rank: rank(el.querySelector('input').value) };
      });
      if (list.some(function (x) { return x.rank === 999; }) || isSorted(list)) return;
      list.sort(function (a, b) { return a.rank - b.rank || a.idx - b.idx; });
      list.forEach(function (x) { box.appendChild(x.el); });
    });
  }

  // Standard-Variantenauswahl (Dawn): fieldset mit input + label Paaren
  function sortDawn(root) {
    root.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
      var inputs = Array.prototype.slice.call(fs.querySelectorAll(':scope > input[type="radio"]'));
      if (inputs.length < 2) return;
      var list = inputs.map(function (inp, idx) {
        var label = inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null;
        return { inp: inp, label: label, idx: idx, rank: rank(inp.value) };
      });
      if (list.some(function (x) { return x.rank === 999 || !x.label; }) || isSorted(list)) return;
      list.sort(function (a, b) { return a.rank - b.rank || a.idx - b.idx; });
      list.forEach(function (x) {
        fs.appendChild(x.inp);
        fs.appendChild(x.label);
      });
    });
  }

  function run() {
    sortTeeinblue(document);
    sortDawn(document);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Versandhinweis direkt am Teeinblue-Preis: "inkl. MwSt. · zzgl. Versand ab 4,90 €" (Daniel, 2026-10-29).
   Steht hier, weil diese Datei auf allen Produktseiten geladen wird. Einzeilig, damit sich der
   Preisblock nicht über die Vorteile-Liste schiebt. "Versand ab 4,90 €" öffnet beim Antippen bzw.
   Drüberfahren ein kleines Infofenster (kein Link, damit niemand die Produktseite verlässt).
   Bei Änderung der Versandkosten hier, in locales/de.json (products.product.shipping_policy_html)
   und in snippets/apportino-structured-data.liquid mit anpassen. */
(function () {
  var HTML =
    ' · zzgl. <button type="button" class="apportino-ship-btn" aria-expanded="false">Versand ab 4,90 €</button>' +
    '<span class="apportino-ship-pop" role="tooltip">' +
    '<strong>Deutschland:</strong> 4,90 € · 4–6 Werktage<br>' +
    '<strong>Österreich:</strong> 6,90 € · 6–9 Werktage<br>' +
    'Ab 50 € Bestellwert versandkostenfrei' +
    '</span>';

  var CSS =
    '.apportino-tee-shipping{position:relative;font-size:inherit;}' +
    '.apportino-ship-btn{background:none;border:0;padding:0;margin:0;font:inherit;color:inherit;' +
    'text-decoration:underline;text-underline-offset:2px;cursor:pointer;letter-spacing:inherit;}' +
    '.apportino-ship-pop{display:none;position:absolute;right:0;top:calc(100% + 6px);z-index:50;' +
    'width:max-content;max-width:min(300px,calc(100vw - 32px));white-space:normal;text-align:left;font-size:13px;line-height:1.5;' +
    'color:rgb(30,30,29);background:#fff;border:1px solid rgba(30,30,29,.15);border-radius:6px;' +
    'box-shadow:0 4px 14px rgba(0,0,0,.12);padding:10px 12px;}' +
    '.apportino-tee-shipping.is-open .apportino-ship-pop{display:block;}' +
    '@media (hover:hover){.apportino-tee-shipping:hover .apportino-ship-pop{display:block;}}';

  function addStyle() {
    if (document.getElementById('apportino-ship-style')) return;
    var style = document.createElement('style');
    style.id = 'apportino-ship-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function run() {
    document.querySelectorAll('.apportino-tee-tax').forEach(function (tax) {
      if (tax.querySelector('.apportino-tee-shipping')) return;
      addStyle();
      var span = document.createElement('span');
      span.className = 'apportino-tee-shipping';
      span.innerHTML = HTML;
      tax.appendChild(span);
    });
  }

  function close(except) {
    document.querySelectorAll('.apportino-tee-shipping.is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      el.querySelector('.apportino-ship-btn').setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.apportino-ship-btn');
    if (!btn) {
      close(null);
      return;
    }
    event.preventDefault();
    var box = btn.closest('.apportino-tee-shipping');
    var open = !box.classList.contains('is-open');
    close(box);
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close(null);
  });

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
